import { useQuery } from '@tanstack/react-query'
import { useAuthQuery } from 'hooks/useAuthQuery'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getProfile } from 'services/AuthService'
import { QueryMetaType } from 'types/reactQuery'

export const useProfileQuery = () => {
  const { isQueryAllowed } = useAuthQuery()
  const meta: QueryMetaType = { isFatalLoginQuery: true }

  return useQuery({
    queryKey: reactQueryKeys.profile(),
    queryFn: getProfile,
    enabled: isQueryAllowed,
    meta,
  })
}
